/**
 * Shared utility functions including cn() for Tailwind class merging.
 * Used throughout shadcn/ui components for conditional styling.
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind CSS classes with clsx
 * Used by shadcn/ui components for conditional class merging
 * @param inputs - class values to merge
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
